import sT from './SessionTypes'

export const SESSION_TYPES = sT
